import React, { Component } from 'react';
import { Button, Label } from 'semantic-ui-react'

class ComparisonCollapsibleCard extends Component {
  constructor(props){
    super(props)

    this.state = {
      expanded: this.props.expand === undefined || this.props.expand === null ? false: this.props.expand
    }
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      expanded: nextProps.expand === undefined || nextProps.expand === null ? this.state.expanded: nextProps.expand,
    })
  }

  onToggle = () => {
    if (this.props.onCardClick){
      this.props.onCardClick()
    }
  }

  render() {
    const { headerLabel, headerText, headerContent, className, content } = this.props

    return (
      <div className="collapsible">
        <div className="collapsible header" onClick={ () => this.onToggle() }>
          <div className="collapsible-header-label">
            { className !== "unwanted-event" &&
              <Button icon={ this.state.expanded? "minus": "plus" } />
            }
            <Label className={ "text " + className }>{ headerLabel }</Label>
          </div>
          <div className="collapsible-header-text">
            { headerContent ? headerContent : headerText }
          </div>
        </div>
        <div className={ "collapsible content " + this.state.expanded }>
          { content }
        </div>
      </div>
    )
  }
}

export default ComparisonCollapsibleCard



// WEBPACK FOOTER //
// ./src/components/comparison_collapsible_card.js